import Http from './http'

class ReservaService {
  constructor() {
    this.baseUrl = '/reservas'
  }

  getAll(filter) {
    let url = `${this.baseUrl}`

    if (filter) {
      url += `?${this.buildFilterUrl(filter)}`
    }
    return Http.get(url)
  }

  nova(reserva) {
    return Http.post(this.baseUrl, reserva)
  }

  resolver(id, valor) {
    const resolver = { resolvido: valor }
    return Http.put(`${this.baseUrl}/${id}/resolver`, resolver)
  }
  
  buildFilterUrl(filter) {
    return Object.keys(filter)
      .map((key) => {
        if (key === 'orderBy') {
          return filter.orderBy.map(
            (order) => `orderBy[]=${order.orderBy},${order.direction || 'asc'}`
          )
        }
        if (filter[key] === null || filter[key] === '') {
          return ''
        }
        return `${key}=${filter[key]}`
      })
      .join('&')
  }
}

export default new ReservaService()
